const select =
  'id,sequenceId,pattern,automaticNumbersCurrentYear,automaticNumbersCurrentMonth,automaticNumbersCurrentDay,lastGeneratedNumber,rowVersion,creator,modifier,created,updated';

export default {
  paged: {
    select: `${select}`,
    searchSelect: ['pattern', 'creator', 'modifier'],
    notSelectSearch: 'id,sequenceId',
  },
  detail: {
    select: `${select}`,
    expand: {
      process: { select: 'name' },
      userCreator: { select: 'fullName' },
    },
  },
  edit: {
    select: `${select}`,
  },
  allowed: {
    select: `${select}`,
    searchSelect: ['name'],
    expand: {
      process: { select: 'name' },
      userCreator: { select: 'fullName' },
    },
    notSelectSearch: 'id',
    orderBy: 'name',
  },
};
